import { ReferenceData } from '../../types/filters'

export const driveTypesData: ReferenceData[] = [
  { label: 'Four-wheel drive', value: 'four-wheel drive' },
  { label: 'Front-wheel drive', value: 'front-wheel drive' },
  { label: 'Rear-wheel drive', value: 'rear-wheel drive' },
]
